<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Ricalcola data fine abbonamento</span>
        <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="content m-0 p-24" fxLayout="column">
    <p class="mb-16 warning-text">
        Stai per aggiornare la <strong>data fine abbonamento</strong> dell'utente, che verrà modificata facendo partire
        l'abbonamento dalla data di pagamento dell'ordine. <br><br><strong>Attenzione: Usa questa funzione solo se sai cosa stai facendo!</strong>
    </p>
    <form [formGroup]="form">
        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>Ticket riferimento id</mat-label>
               <input matInput autocomplete="doNotAutoComplete" placeholder="" formControlName="ticketId" />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" />
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Annulla</button>
    <button mat-raised-button color="accent" (click)="onConferma()" [disabled]="form.invalid">Conferma</button>
</mat-dialog-actions>
